import React, { useEffect } from 'react';
import { useLocation } from 'wouter';

interface SidebarItem {
  label: string;
  path: string;
  icon: string;
}

const sidebarItems: SidebarItem[] = [
  { label: 'Dashboard', path: '/', icon: 'home' },
  { label: 'Analytics', path: '/analytics', icon: 'bar-chart-2' },
  { label: 'Scope 1 Emissions', path: '/scope/scope1', icon: 'zap' },
  { label: 'Scope 2 Emissions', path: '/scope/scope2', icon: 'activity' },
  { label: 'Scope 3 Emissions', path: '/scope/scope3', icon: 'globe' },
  { label: 'Reports & Export', path: '/reports', icon: 'file-text' },
  { label: 'Settings', path: '/settings', icon: 'settings' },
];

export function Sidebar() {
  const [location, setLocation] = useLocation();

  // Initialize feather icons
  useEffect(() => {
    const initializeIcons = () => {
      if (window.feather) {
        window.feather.replace();
      }
    };
    
    // Initialize immediately
    initializeIcons();
    
    // Also initialize after a short delay to ensure DOM is ready
    const timeoutId = setTimeout(initializeIcons, 100);
    
    return () => clearTimeout(timeoutId);
  }, [location]); // Re-initialize when location changes

  return (
    <div className="w-48 bg-green-50 shadow-sm h-screen">
      <div className="p-3">
        <nav className="space-y-1">
          {sidebarItems.map((item) => (
            <button
              key={item.path}
              onClick={() => setLocation(item.path)}
              className={`
                w-full flex items-center px-2 py-1.5 text-left rounded-md transition-colors text-sm
                ${location === item.path
                  ? 'bg-green-100 text-green-800 border-r-2 border-green-700'
                  : 'text-green-700 hover:bg-green-100'
                }
              `}
            >
              <i data-feather={item.icon} className="w-4 h-4 mr-2"></i>
              {item.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}
